export default __webpack_public_path__ + "static/media/gallery_04.444b9b94.jpg";